<template>
  <div class="share-box">
    <div class="app-logo">
      <img src="@/assets/image/share/ic_logo.png" />
    </div>
    <div class="app-info">浙江急救客户端下载平台<br>（{{IsIOS?'iOS':'Android'}}）</div>
    <div style="min-height: calc(100vh - 335px)">
      <div class="app-list">
        <div v-for="(item, index) in sourceList" :key="index">
          <div class="app-item flex-center-between">
            <div class="app-item-left">
              <div class="app-name">{{getName(item.source)}}<span class="app-version">[{{item.version}} (build {{item.build}})]</span></div>
              <div class="update-time">更新时间：{{item.updateTime|dateFilter}}</div>
            </div>
            <div class="app-item-right" @click="openShade(item)">下载</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-shade" v-if="isOpen">
      <div class="app-arr-img">
        <img src="@/assets/image/share/pic_jiantou.png" />
      </div>
      <img src="@/assets/image/share/btn_download.svg" />
      <div class="app-free-tip">通过“浏览器中打开”下载应用吧！</div>
    </div>
    <version></version>
  </div>
</template>

<script>
import {Notify} from "vant";
import Version from "@/components/Version";

export default {
  name: "ShareAll",
  data() {
    return {
      appList:[
        {
          name: 'car',
          text: '车载端',
          device: 'android',
          value: 1,
        },
        {
          name: 'med',
          text: '医疗端',
          des: '医疗安卓端',
          device: 'android',
          value: 2,
        },
        {
          name: 'drive',
          text: '驾驶端',
          des: '驾驶安卓端',
          device: 'android',
          value: 3,
        },
        {
          name: 'med',
          text: '医疗端',
          des: '医疗ios端',
          device: 'ios',
          value: 4,
        },
        {
          name: 'drive',
          text: '驾驶端',
          des: '驾驶ios端',
          device: 'ios',
          value: 5,
        },
        {
          name: 'manage',
          text: '管理端',
          des: '管理安卓端',
          device: 'android',
          value: 6,
        },
        {
          name: 'manage',
          text: '管理端',
          des: '管理ios端',
          device: 'ios',
          value: 7,
        },
        {
          name: 'hos',
          text: '医院端',
          des: '医院ios端',
          device: 'android',
          value: 8,
        },
        {
          name: 'hos',
          text: '医院端',
          des: '医院ios端',
          device: 'ios',
          value: 9,
        },
        {
          name: 'zljj',
          text: '智联急救',
          des: '救护车到达预通知、急救点管理应用端',
          device: 'android',
          value: 20,
        },
        {
          name: 'zljj',
          text: '智联急救',
          des: '救护车到达预通知、急救点管理应用端',
          device: 'ios',
          value: 19,
        },
        {
          name: 'assist',
          text: '辅助人员端',
          des: '急救120辅助ios端',
          device: 'ios',
          value: 30,
        },
        {
          name: 'assist',
          text: '辅助人员端',
          des: '急救120辅助android端',
          device: 'android',
          value: 31,
        }
      ],
      sourceList:[],
      isOpen: false,
      IsIOS: false
    };
  },
  components:{
    Version
  },
  computed:{
    getName(){
      return function (value){
        return this.appList.filter(item => {
          return item.value === value
        })[0].text
      }
    }
  },
  created() {
    // 根据ua判断显示安卓还是ios下载按钮
    const UA = window.navigator.userAgent;
    const IsAndroid = /Android|HTC/i.test(UA) || !!`${window.navigator.platform}`.match(/Linux/i);
    const IsIPad = !IsAndroid && /iPad/i.test(UA);
    const IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
    this.IsIOS = IsIPad || IsIPhone;
    this.getVersion();
  },
  methods: {
    getVersion(){
      window.$common.post('/master/v2/common/get-app-version-list', {
        type: this.IsIOS ? 2 : 1,
        appGroup: 1,
        tag: this.$route.query.tag
      }).then(res => {
        if (res.data.retcode === 1) {
          this.sourceList = res.data.obj;
        } else {
          Notify(res.data.msg.prompt);
        }
      }).catch(err=>{
        Notify(err);
      })
    },
    openShade(item) {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // 在微信中打开
        this.isOpen = true;
      } else {
        // 直接跳转
        if (item.appUrl) {
          // 判断文件后缀，apk，则跳转下载中页面，并下载
          if(item.appUrl.indexOf('.apk') > -1) {
            this.$router.push('/downloading?name=' + this.getName(item.source))
          }
          window.open(item.appUrl);
        } else{
          Notify('下载链接为空');
        }
      }
    }
  },
  filters:{
    dateFilter(val){
      if(val){
        let _val = val.replace(new RegExp(/-/gm), "/");
        return new Date(_val).format('yyyy/MM/dd')
      }else{
        return '--'
      }
    }
  }
};
</script>

<style scoped>
.share-box {
  position: relative;
  font-size: 18px;
  color: #ffffff;
  background-image: url("../../assets/image/share/pic_bg.jpg");
  background-size: cover;
  -moz-background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  min-height: calc(100vh - 20px);
  padding-bottom: 20px;
}
.app-logo img {
  width: 100px;
  margin-top: 50px;
}
.app-info {
  font-weight: bold;
  padding-top: 15px;
  padding-bottom: 30px;
}
.app-list {
  opacity: 0.95;
  background: #FFFFFF;
  border-radius: 10px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 0 15px;
}
.app-name {
  font-size: 16px;
  color: #2A2F4D;
  text-align: left;
}
.app-version{
  font-size: 12px;
  color: #38467B;
  margin-left: 5px;
}
.update-time{
  font-size: 12px;
  color: #747EA3;
  margin-top: 2px;
  text-align: left;
}
.app-item {
  padding: 15px 0;
  position: relative;
}
.app-item::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0;
  top: 0;
  left: 0;
  border-bottom: 1px solid rgba(63,99,232,0.15);
  transform: scaleY(0.5);
}
.app-item-right {
  cursor: pointer;
  background: #5C82EE;
  border-radius: 14px;
  font-size: 14px;
  padding: 3px 15px;
}
.box-shade {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.app-arr-img {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
}
.app-arr-img img {
  height: 45vh;
  cursor: pointer;
}
.app-free-tip {
  font-size: 15px;
  padding-top: 10px;
}
</style>
